import React from "react";
import JobListings from "../../components/job-listings";
import LazyLoad from "react-lazyload";
import { Helmet } from "react-helmet";
import { fetchJobs } from "../../../store/thunks/jobs";
import { filterJobs } from "../../../utils/filter";
import { Footer } from "../../components/footer";
import { PopularCategories } from "../../components/popular-categories";
import { metaStatuses } from "../../../store/state/meta-state";
import { JobsByLocation } from "../../components/jobs-by-location";
import { setCategory } from "../../../utils/set-category";
import { SmallHero } from "../../components/small-hero";
import { PowerSearchHero } from "../../components/power-search-hero";
import { RemoteResume } from "../../components/remote-resume";

export class NewShowJobs extends React.Component {
  static fetchData(store, url) {
    return store.dispatch(fetchJobs());
  }

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.jobsRef = React.createRef();
  }

  componentDidMount() {
    const { meta, clearFilters, fetchJobs, category } = this.props;

    window.scrollTo(0, 0);

    clearFilters(setCategory(category));
    if (meta.status === metaStatuses.DEFAULT) {
      fetchJobs();
    }
  }

  setHeading = () => {
    const { category } = this.props;
    if (category === "customerservice") {
      return "customer service";
    }

    if (category === "devopsandsysadmin") {
      return "devops and sysadmin";
    }

    if (category === "seo") {
      return "SEO";
    }

    if (category === "manager") {
      return "manager/exec";
    }
    if (category === "hr") {
      return "HR";
    }

    return category;
  };

  render() {
    const {
      jobs,
      addFilter,
      removeFilter,
      clearFilters,
      filtersApplied,
      filters,
      category,
      removeFromFilters,
      addToFilters,
      pageTitle,
      pageDesc,
      meta,
      canonical,
    } = this.props;

    const filteredJobs = jobs && filterJobs(jobs, filters);
    const featuredJobs = jobs && jobs.filter((job) => job.is_featured === true);

    return (
      <>
        <Helmet>
          <title>{pageTitle}</title>
          <meta name="description" content={pageDesc} />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <div>
          <SmallHero category={category} />
          <div ref={this.jobsRef} />
          <JobListings
            featuredJobs={featuredJobs}
            meta={meta}
            category={category}
            filters={filters}
            filtersApplied={filtersApplied}
            filteredJobs={filteredJobs}
            addFilter={addFilter}
            removeFilter={removeFilter}
            clearFilters={clearFilters}
            jobs={jobs}
            removeFromFilters={removeFromFilters}
            addToFilters={addToFilters}
          />
          <JobsByLocation />
          <div ref={this.myRef} />
          <PowerSearchHero
            tracking={{
              action: `PowerSearch - Job Listings ${category} - BottomHero`,
            }}
          />
          <LazyLoad offset={1000} height={466} once>
            <PopularCategories />
          </LazyLoad>
          <RemoteResume
            tracking={{
              action: `Resumeio - Job Listings ${category} - BottomHero`,
            }}
          />
        </div>
        <Footer />
      </>
    );
  }
}

export default NewShowJobs;
